// third-party
import { FormattedMessage } from "react-intl";

// assets
import { BrifecaseTick } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  orders: BrifecaseTick,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const finance: NavItemType = {
  id: "group-finance",
  title: <FormattedMessage id="page.menu_items_finance_label" />,
  icon: icons.orders,
  type: "group",
  children: [
    {
      id: "group-finance",
      title: <FormattedMessage id="page.menu_items_finance_label" />,
      type: "collapse",
      icon: icons.orders,
      children: [
        {
          id: "finance-orders",
          title: <FormattedMessage id="page.menu_items_finance_orders_label" />,
          type: "item",
          url: "/orders/list",
        },
        {
          id: "finance-payout",
          title: <FormattedMessage id="page.menu_items_finance_payout_label" />,
          type: "item",
          url: "/payout/list",
        },
        {
          id: "finance-refund",
          title: <FormattedMessage id="page.menu_items_finance_refund_label" />,
          type: "item",
          url: "/refund/list",
        },
        {
          id: "finance-payout-list",
          title: (
            <FormattedMessage id="page.menu_items_complete_payout_label" />
          ),
          type: "item",
          url: "/payout-list",
        },
        {
          id: "finance-failed-order",
          title: (
            <FormattedMessage id="page.menu_items_finance_failed_order_label" />
          ),
          type: "item",
          url: "/failed-order/list",
        },
      ],
    },
  ],
};

export default finance;
